<template>
  <layout :title="title" :loading="isLoading">
    <template v-slot:title>
      {{ title }}
      <router-link :to="{ name: 'update-affiliate', params: { id: item.id } }">
        <primary-button v-if="hasEdit('affiliates')" class="ml-2" height="35px">
          View Profile
        </primary-button>
      </router-link>
    </template>
    <v-tabs class="tab-outlined" hide-slider v-model="tab">
      <v-tab class="text-none">Weekly</v-tab>
      <v-tab class="text-none">Daily</v-tab>
      <v-tab class="text-none" v-if="hasTiers">Tiers</v-tab>
    </v-tabs>
    <v-divider></v-divider>
    <v-tabs-items v-model="tab">
      <v-tab-item :transition="false">
        <affiliate-weekly-commissions :affiliate="item" />
      </v-tab-item>
      <v-tab-item :transition="false">
        <affiliate-daily-commissions :affiliate="item" />
      </v-tab-item>
      <v-tab-item :transition="false" v-if="hasTiers">
        <affiliate-commission-tiers :affiliate="item" />
      </v-tab-item>
    </v-tabs-items>
  </layout>
</template>

<script>
import Layout from "@/components/ui/Layout.vue";
import {doc, getDoc} from "firebase/firestore";
import {colAffiliates} from "@/assets/utils/firebase.utils";
import AffiliateWeeklyCommissions from "@/components/affiliates/AffiliateWeeklyCommissions.vue";
import AffiliateDailyCommissions from "@/components/affiliates/AffiliateDailyCommissions.vue";
import AffiliateCommissionTiers from "@/components/affiliates/AffiliateCommissionTiers.vue";
import EditIconButton from "@/components/ui/buttons/EditIconButton.vue";
import PrimaryButton from "@/components/ui/buttons/PrimaryButton.vue";

export default {
  components: {
    PrimaryButton,
    EditIconButton,
    Layout,
    AffiliateWeeklyCommissions,
    AffiliateDailyCommissions,
    AffiliateCommissionTiers,
  },
  data() {
    return {
      isLoading: true,
      tab: 0,
      item: {},
    };
  },
  computed: {
    hasTiers() {
      return (this.item.commission_tiers || []).length > 0;
    },
    affiliateId() {
      return this.$route.params.id;
    },
    title() {
      return `Commission for ${this.item.first_name || ""} ${
        this.item.last_name || ""
      }`;
    },
  },
  methods: {
    async init() {
      const vm = this;
      try {
        vm.isLoading = true;
        let affiliate = (
          await getDoc(doc(colAffiliates, vm.affiliateId))
        ).data();
        if (affiliate == null) {
          vm.notifyError("Affiliate not found");
          vm.$router.replace({ name: "affiliates" });
          return;
        }
        vm.item = { ...affiliate, id: vm.affiliateId };
        vm.isLoading = false;
      } catch (error) {
        vm.handleError(error.message);
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style></style>
